import { ErrorResponse } from '@apollo/client/link/error';
import { getCreateCtxNonceIdempotent } from '@next-safe/middleware/dist/document';
import { GraphQLError } from 'graphql';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import { getStatus } from '@/utils/guards/status';

function notFound(): { notFound: true } {
  return { notFound: true };
}

function props<Q extends GetServerSidePropsContext, P extends { [key: string]: any }>(
  c: Q,
  p: P,
): GetServerSidePropsResult<P> {
  const nonce = getCreateCtxNonceIdempotent(c);
  return {
    props: { ...p, nonce, params: JSON.parse(JSON.stringify(c.params || {})) },
  };
}

function redirect(destination: string, permanent = false) {
  return {
    redirect: {
      permanent,
      destination,
    },
  };
}

function apolloErrors(graphQLErrors?: ReadonlyArray<GraphQLError>) {
  if (graphQLErrors?.some(gqlError => getStatus(gqlError?.extensions?.response) === 404)) {
    return redirect('/404');
  }

  return redirect('/500');
}

function isErrorResponse(unknownObject: unknown): unknownObject is ErrorResponse {
  const requiredKeys = ['graphQLErrors', 'networkError'];

  if (typeof unknownObject !== 'object') {
    return false;
  }

  for (const unknownKey in unknownObject) {
    if (requiredKeys.includes(unknownKey)) {
      return true;
    }
  }

  return false;
}

function tryCatch(error: unknown) {
  if (!isErrorResponse(error)) {
    return redirect('/500');
  }

  return apolloErrors(error.graphQLErrors);
}

export { apolloErrors, notFound, props, redirect, tryCatch };
